import React, { useEffect, useMemo, useState } from "react";
import { FiFileText, FiSearch, FiDownload, FiRefreshCw } from "react-icons/fi";

export default function BrandClaimReport() {
  const [brand, setBrand] = useState("Allen Solly");
  const [billFrom, setBillFrom] = useState("CCPL0100");
  const [billTo, setBillTo] = useState("CCPL0200");
  const [requiredQty, setRequiredQty] = useState(100);
  const [generated, setGenerated] = useState(false);
  const [month, setMonth] = useState("2026-07");
  const [reportDateFrom, setReportDateFrom] = useState("2026-07-20");
  const [reportDateTo, setReportDateTo] = useState("2026-07-31");
  const [reportBillFrom, setReportBillFrom] = useState("CCPL1000");
  const [previewRows, setPreviewRows] = useState([]);

  const salesData = [
    {
      id: 1,
      billNo: "CCPL0100",
      date: "2026-07-01",
      brand: "Allen Solly",
      barcode: "8901456123456",
      sku: "ALS-SH-001-BLK-L",
      product: "Premium Linen Shirt",
      color: "Black",
      size: "L",
      qty: 1,
      mrp: 2499,
      discount: 200,
      net: 2299,
      isReported: false,
    },
    {
      id: 2,
      billNo: "CCPL0100",
      date: "2026-07-01",
      brand: "Allen Solly",
      barcode: "8901456123457",
      sku: "ALS-CS-001-PNK-M",
      product: "Premium Cord Set",
      color: "Pink",
      size: "M",
      qty: 1,
      mrp: 3999,
      discount: 500,
      net: 3499,
      isReported: false,
    },
    {
      id: 3,
      billNo: "CCPL0100",
      date: "2026-07-01",
      brand: "Allen Solly",
      barcode: "8901456123458",
      sku: "ALS-CS-001-PNK-M",
      product: "Premium Cord Set",
      color: "Pink",
      size: "M",
      qty: 1,
      mrp: 3999,
      discount: 500,
      net: 3499,
      isReported: false,
    },

    {
      id: 4,
      billNo: "CCPL0101",
      date: "2026-07-02",
      brand: "Allen Solly",
      barcode: "8901456123459",
      sku: "ALS-SH-002-BLU-XL",
      product: "Casual Shirt",
      color: "Blue",
      size: "XL",
      qty: 1,
      mrp: 2199,
      discount: 100,
      net: 2099,
      isReported: false,
    },
    {
      id: 5,
      billNo: "CCPL0101",
      date: "2026-07-02",
      brand: "Allen Solly",
      barcode: "8901456123460",
      sku: "ALS-TS-001-WHT-M",
      product: "Printed T-Shirt",
      color: "White",
      size: "M",
      qty: 1,
      mrp: 1499,
      discount: 150,
      net: 1349,
      isReported: false,
    },

    {
      id: 6,
      billNo: "CCPL0102",
      date: "2026-07-03",
      brand: "Allen Solly",
      barcode: "8901456123461",
      sku: "ALS-JN-001-NVY-32",
      product: "Slim Fit Jeans",
      color: "Navy",
      size: "32",
      qty: 1,
      mrp: 2999,
      discount: 250,
      net: 2749,
      isReported: false,
    },
    {
      id: 7,
      billNo: "CCPL0102",
      date: "2026-07-03",
      brand: "Allen Solly",
      barcode: "8901456123462",
      sku: "ALS-JN-001-NVY-34",
      product: "Slim Fit Jeans",
      color: "Navy",
      size: "34",
      qty: 1,
      mrp: 2999,
      discount: 250,
      net: 2749,
      isReported: false,
    },

    {
      id: 8,
      billNo: "CCPL0103",
      date: "2026-07-04",
      brand: "Allen Solly",
      barcode: "8901456123463",
      sku: "ALS-SH-003-WHT-L",
      product: "Formal Shirt",
      color: "White",
      size: "L",
      qty: 1,
      mrp: 2699,
      discount: 300,
      net: 2399,
      isReported: false,
    },

    {
      id: 9,
      billNo: "CCPL0104",
      date: "2026-07-05",
      brand: "Allen Solly",
      barcode: "8901456123464",
      sku: "ALS-TR-001-BLK-34",
      product: "Formal Trouser",
      color: "Black",
      size: "34",
      qty: 1,
      mrp: 2899,
      discount: 200,
      net: 2699,
      isReported: false,
    },

    {
      id: 10,
      billNo: "CCPL0105",
      date: "2026-07-06",
      brand: "Allen Solly",
      barcode: "8901456123465",
      sku: "ALS-PO-001-GRN-M",
      product: "Polo T-Shirt",
      color: "Green",
      size: "M",
      qty: 1,
      mrp: 1799,
      discount: 100,
      net: 1699,
      isReported: true,
    },

    {
      id: 11,
      billNo: "CCPL0106",
      date: "2026-07-07",
      brand: "Allen Solly",
      barcode: "8901456123466",
      sku: "ALS-SH-004-MRN-XL",
      product: "Premium Shirt",
      color: "Maroon",
      size: "XL",
      qty: 1,
      mrp: 2599,
      discount: 250,
      net: 2349,
      isReported: false,
    },

    {
      id: 12,
      billNo: "CCPL0107",
      date: "2026-07-08",
      brand: "Allen Solly",
      barcode: "8901456123467",
      sku: "ALS-KR-001-BLU-L",
      product: "Cotton Kurta",
      color: "Blue",
      size: "L",
      qty: 1,
      mrp: 2399,
      discount: 200,
      net: 2199,
      isReported: false,
    },
  ];

  const salesPreview = useMemo(() => {
 

    const pendingItems = salesData.filter((item) => {
      const itemMonth = item.date.substring(0, 7);

      return item.brand === brand && itemMonth === month && !item.isReported;
    });

    let remaining = requiredQty;

    let currentBill = Number(reportBillFrom.replace(/\D/g, ""));

    const billPrefix = reportBillFrom.replace(/[0-9]/g, "");

    const startDate = new Date(reportDateFrom);

    const endDate = new Date(reportDateTo);

    const totalDays = Math.max(
      1,
      Math.floor((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1,
    );

    let currentDateIndex = 0;

    let currentBillItems = 0;

    const preview = [];

    pendingItems.forEach((item) => {
      if (remaining <= 0) return;

      preview.push({
        ...item,

        reportBillNo: billPrefix + String(currentBill).padStart(4, "0"),

        reportDate: new Date(
          startDate.getTime() + currentDateIndex * 24 * 60 * 60 * 1000,
        )
          .toISOString()
          .substring(0, 10),
      });

      remaining--;

      currentBillItems++;

      const limit = Math.floor(Math.random() * 4) + 2;

      if (currentBillItems >= limit) {
        currentBill++;
        currentBillItems = 0;

        if (currentDateIndex < totalDays - 1) {
          currentDateIndex++;
        }
      }
    });

    return preview;
  }, [
    brand,
    month,
    reportBillFrom,
    reportDateFrom,
    reportDateTo,
    requiredQty,
    salesData,
  ]);

  const generatePreview = () => {
  setPreviewRows(
    salesPreview.map((row) => ({
      ...row,
    }))
  );

  setGenerated(true);
};

  const totalQty = previewRows.reduce((sum, item) => sum + item.qty, 0);

  const totalValue = previewRows.reduce((sum, item) => sum + item.net, 0);

  const totalBills = [...new Set(previewRows.map((i) => i.billNo))].length;

  const stockPreview = useMemo(() => {
    const grouped = {};

    previewRows.forEach((item) => {
      const key = `${item.barcode}_${item.size}_${item.color}`;

      if (!grouped[key]) {
        grouped[key] = {
          brand: item.brand,
          barcode: item.barcode,
          sku: item.sku,
          product: item.product,
          color: item.color,
          size: item.size,
          purchased: 100,
          sold: 0,
          stock: 100,
          mrp: item.mrp,
        };
      }

      grouped[key].sold += item.qty;
      grouped[key].stock = grouped[key].purchased - grouped[key].sold;
    });

    return Object.values(grouped);
  }, [previewRows]);

  return (
    <div className="min-h-screen bg-[#F8F6F5]">
      {/* Header */}

      <div className="mb-8 flex items-center justify-between">
        <div>
          <h1 className="text-4xl font-bold text-primary-800">
            Brand Claim Report
          </h1>

          <p className="mt-2 text-gray-500">
            Generate Sales & Stock Report from POS Bills
          </p>
        </div>

        <button className="flex items-center gap-2 rounded-2xl bg-primary-800 px-6 py-3 text-white">
          <FiDownload />
          Export
        </button>
      </div>

      {/* Filters */}

      <div className="rounded-3xl bg-white p-8 shadow-sm">
        <h2 className="mb-6 text-2xl font-bold text-primary-800">
          Generate Report
        </h2>

        <div className="grid grid-cols-3 gap-6">
          {/* Brand */}

          <div>
            <label className="mb-2 block font-medium">Brand</label>

            <select
              value={brand}
              onChange={(e) => setBrand(e.target.value)}
              className="w-full rounded-xl border p-3"
            >
              <option>Allen Solly</option>

              <option>Louis Philippe</option>

              <option>Van Heusen</option>
            </select>
          </div>

          {/* Month */}

          <div>
            <label className="mb-2 block font-medium">
              Original Sales Month
            </label>

            <input
              type="month"
              value={month}
              onChange={(e) => setMonth(e.target.value)}
              className="w-full rounded-xl border p-3"
            />
          </div>

          {/* Qty */}

          <div>
            <label className="mb-2 block font-medium">Required Quantity</label>

            <input
              type="number"
              value={requiredQty}
              onChange={(e) => setRequiredQty(Number(e.target.value))}
              className="w-full rounded-xl border p-3"
            />
          </div>
        </div>

        <hr className="my-8" />

        <h3 className="mb-6 text-xl font-bold">Generated Report Details</h3>

        <div className="grid grid-cols-3 gap-6">
          <div>
            <label className="mb-2 block">Report Date From</label>

            <input
              type="date"
              value={reportDateFrom}
              onChange={(e) => setReportDateFrom(e.target.value)}
              className="w-full rounded-xl border p-3"
            />
          </div>

          <div>
            <label className="mb-2 block">Report Date To</label>

            <input
              type="date"
              value={reportDateTo}
              onChange={(e) => setReportDateTo(e.target.value)}
              className="w-full rounded-xl border p-3"
            />
          </div>

          <div>
            <label className="mb-2 block">Report Bill From</label>

            <input
              value={reportBillFrom}
              onChange={(e) => setReportBillFrom(e.target.value)}
              className="w-full rounded-xl border p-3"
            />
          </div>
        </div>

        <div className="mt-8 flex justify-end">
          <button
            onClick={generatePreview}
            className="rounded-xl bg-primary-800 px-8 py-3 text-white"
          >
            Generate Preview
          </button>
        </div>
      </div>

      {/* Summary */}

      {generated && (
        <div className="mt-8 rounded-3xl bg-white p-6 shadow-sm">
          <div className="grid grid-cols-4 gap-6">
            <div>
              <p className="text-gray-500">brand</p>

              <h3 className="mt-2 text-2xl font-bold">{brand}</h3>
            </div>

            <div>
              <p className="text-gray-500">Bill Range</p>

              <h3 className="mt-2 text-xl font-semibold">
                {billFrom} - {billTo}
              </h3>
            </div>

            <div>
              <p className="text-gray-500">Required Qty</p>

              <h3 className="mt-2 text-2xl font-bold">{requiredQty}</h3>
            </div>

            <div>
              <p className="text-gray-500">Status</p>

              <span className="mt-2 inline-block rounded-full bg-green-100 px-4 py-2 text-green-700">
                Ready to Generate
              </span>
            </div>
          </div>
        </div>
      )}

      {generated && (
        <div className="mt-8 rounded-3xl bg-white shadow-sm">
          <div className="flex items-center justify-between border-b p-6">
            <div>
              <h2 className="text-2xl font-bold text-primary-800">
                Sales Report Preview
              </h2>

              <p className="text-gray-500">Verify before generating Excel</p>
            </div>

            <button className="rounded-xl border px-5 py-2">Refresh</button>
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full">
              <thead className="bg-[#F8F6F5]">
                <tr>
                  <th className="px-4 py-3 text-left">Report Bill</th>
                  <th className="px-4 py-3">Report Date</th>
                  <th className="px-4 py-3">Original Bill</th>
                  <th className="px-4 py-3">Original Date</th>
                  <th className="px-4 py-3">Barcode</th>
                  <th className="px-4 py-3">SKU</th>
                  <th className="px-4 py-3">Product</th>
                  <th className="px-4 py-3">Color</th>
                  <th className="px-4 py-3">Size</th>
                  <th className="px-4 py-3">Qty</th>
                  <th className="px-4 py-3">MRP</th>
                  <th className="px-4 py-3">Discount</th>
                  <th className="px-4 py-3">Net</th>
                </tr>
              </thead>

              <tbody>
                {previewRows.map((item, index) => (
                  <tr key={index} className="border-b hover:bg-gray-50">
                    <td className="px-4 py-3">
                      <input
                        value={item.reportBillNo}
                        onChange={(e) => {
                          const updated = [...previewRows];

                          updated[index].reportBillNo = e.target.value;

                          setPreviewRows(updated);
                        }}
                        className="w-32 rounded-lg border p-2"
                      />
                    </td>

                    <td className="px-4 py-3">
                      <input
                        type="date"
                        value={item.reportDate}
                        onChange={(e) => {
                          const updated = [...previewRows];

                          updated[index].reportDate = e.target.value;

                          setPreviewRows(updated);
                        }}
                        className="rounded-lg border p-2"
                      />
                    </td>
                    <td className="px-4 py-3 font-semibold">{item.billNo}</td>
                    <td className="px-4 py-3">{item.date}</td>

                    <td className="px-4 py-4">{item.barcode}</td>

                    <td className="px-4 py-4">{item.sku}</td>

                    <td className="px-4 py-4">{item.product}</td>

                    <td className="px-4 py-4">{item.color}</td>

                    <td className="px-4 py-4">{item.size}</td>

                    <td className="px-4 py-3 text-center font-semibold">
                      {item.qty}
                    </td>

                    <td className="px-4 py-4">₹{item.mrp}</td>

                    <td className="px-4 py-4">₹{item.discount}</td>

                    <td className="px-4 py-4 font-semibold">₹{item.net}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="grid grid-cols-3 border-t bg-[#F8F6F5] p-6">
            <div>
              <p className="text-gray-500">Bills Selected</p>

              <h3 className="mt-2 text-2xl font-bold">{totalBills}</h3>
            </div>

            <div>
              <p className="text-gray-500">Quantity Selected</p>

              <h3 className="mt-2 text-2xl font-bold text-green-600">
                {totalQty}
              </h3>
            </div>

            <div>
              <p className="text-gray-500">Net Value</p>

              <h3 className="mt-2 text-2xl font-bold">
                ₹{totalValue.toLocaleString()}
              </h3>
            </div>
          </div>
        </div>
      )}

      {generated && (
        <div className="mt-8 rounded-3xl bg-white shadow-sm">
          <div className="border-b p-6">
            <h2 className="text-2xl font-bold text-primary-800">
              Stock Report Preview
            </h2>

            <p className="text-gray-500 mt-1">Stock after selected sales</p>
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full">
              <thead className="bg-[#F8F6F5]">
                <tr>
                  <th className="px-4 py-3 text-left">Barcode</th>

                  <th className="px-4 py-3">SKU</th>

                  <th className="px-4 py-3">Product</th>

                  <th className="px-4 py-3">Color</th>

                  <th className="px-4 py-3">Size</th>

                  <th className="px-4 py-3">Purchased</th>

                  <th className="px-4 py-3">Sold</th>

                  <th className="px-4 py-3">Stock</th>

                  <th className="px-4 py-3">MRP</th>
                </tr>
              </thead>

              <tbody>
                {stockPreview.map((item, index) => (
                  <tr key={index} className="border-b hover:bg-gray-50">
                    <td className="px-4 py-4">{item.barcode}</td>

                    <td className="px-4 py-4">{item.sku}</td>

                    <td className="px-4 py-4 font-medium">{item.product}</td>

                    <td className="px-4 py-4">{item.color}</td>

                    <td className="px-4 py-4">{item.size}</td>

                    <td className="px-4 py-4 text-center">{item.purchased}</td>

                    <td className="px-4 py-4 text-center text-red-600 font-semibold">
                      {item.sold}
                    </td>

                    <td className="px-4 py-4 text-center text-green-700 font-bold">
                      {item.stock}
                    </td>

                    <td className="px-4 py-4">₹{item.mrp}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Export Buttons */}

      {generated && (
        <div className="mt-8 flex justify-end gap-4">
          <button className="rounded-2xl border px-6 py-3 font-semibold hover:bg-gray-100">
            Export Sales Report
          </button>

          <button className="rounded-2xl border px-6 py-3 font-semibold hover:bg-gray-100">
            Export Stock Report
          </button>

          <button className="rounded-2xl bg-primary-800 px-6 py-3 font-semibold text-white">
            Export Both Reports
          </button>
        </div>
      )}
    </div>
  );
}
